import { Tag } from '@weave/schema-gen-ts/dist/schemas/tag/shared/v1/models.pb';
import { CallRecordsFiltersType } from '../../hooks/use-phone-config-state-store';
import { getFormattedCallerName } from '../../utils';
import { HydratedCallRecord } from '../all-calls/types';

export const getFallbackCallerName = (callInfo: HydratedCallRecord) => {
  const { direction, callerNumber, dialedNumber } = callInfo;
  return direction === 'inbound'
    ? getFormattedCallerName(callerNumber ?? '')
    : getFormattedCallerName(dialedNumber ?? '');
};

export const getShortHandName = (callInfo: HydratedCallRecord) => {
  const { person } = callInfo;
  return !!person?.firstName ? `${person?.firstName ?? ''}` : getFallbackCallerName(callInfo);
};

export const getRecentCallsSearchQuery = (
  filters: CallRecordsFiltersType | undefined,
  pageSize: number,
  mappedTags: Record<string, Tag>
) => `${JSON.stringify({ ...filters })}-${pageSize}-${Object.keys(mappedTags || {}).length}`;

export const toPascalCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
